export default {
  state: {
    queues: {},
    paused: {},
    content: {},
    hash: null,
  },
};
